import {
  createSlice,
  createSelector,
  createAsyncThunk,
  createEntityAdapter
} from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { API_PATH } from '../../constants';
import { IOrganization } from '../../interfaces';
import { http } from '../../utils/config';

const organizationAdapter = createEntityAdapter<IOrganization>({
  selectId: (org) => org.id
})

const initialState = organizationAdapter.getInitialState()

// Thunk functions
export const fetchOrganizations = createAsyncThunk('organization/fetchOrganizations', async () => {
  try {
  
    const response = await http.get(API_PATH + "/organization");
    //console.log("response.data: ", response.data)
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return error.response.data.message
    } else {
      return error.message
    }
  }
})

const organizationSlice = createSlice({
    name: 'organizations',
    initialState,
    reducers: {
      organizationToggled(state, action) {
        //const organizationId = action.payload
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchOrganizations.fulfilled, (state, action) => {
          organizationAdapter.setAll(state, action.payload)
        })
    },
})

export const {
  organizationToggled
} = organizationSlice.actions

export default organizationSlice.reducer

export const {
  selectAll: selectOrganizations
} = organizationAdapter.getSelectors((state: RootState) => state.organizations)

export const selectOrganizationsSlice = createSelector(
  selectOrganizations,
  (organizations: IOrganization[]) => { 
    //console.log("selectOrganization: ", organizations)
    return organizations.map((organization: IOrganization) => {
      return organization;
    })
  }
)

export const updateOrganization = createAsyncThunk(
  'organizations/updateOrganization',
  async (text: IOrganization) => {
    try {
  
      const response = await http.put(API_PATH + '/organization/' + text.id + '/info', { 'info': text });
      return response.status
    } catch (error: any) {
      return error;
    }
  }
)

export const createOrganization = createAsyncThunk(
  'organizations/createOrganization',
  async (orgName: string, { rejectWithValue }) => {
    try {
      let response: any = await http.post(API_PATH + '/organization/new', { orgName });
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getOrganization = createAsyncThunk(
  'organizations/publishOrganization',
  async (id: string, { rejectWithValue }) => {
    try {

      let response: any = await http.get(API_PATH + '/organization/' + id);
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteOrganization = createAsyncThunk(
  'organizations/copyOrganization',
  async (id: string, { rejectWithValue }) => {
    try {

      let response: any = await http.delete(API_PATH + '/organization/' + id);
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

